import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { AlertTriangle, X, Calculator } from 'lucide-react';
import { FiscalCountdown } from './FiscalCountdown';

export const FiscalBanner = ({ onSimulatorClick }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div 
      className="bg-gradient-to-r from-orange-600 via-red-600 to-orange-600 text-white py-2 sm:py-3 px-3 sm:px-4 relative"
      data-testid="fiscal-banner"
    >
      <div className="mx-auto w-full max-w-[var(--container)] flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-3">
        <div className="flex items-center gap-2 sm:gap-3 flex-wrap justify-center sm:justify-start">
          <AlertTriangle className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 animate-pulse" />
          <span className="text-xs sm:text-sm md:text-base font-medium text-center sm:text-left leading-tight">
            <strong>Réforme fiscale votée en Suisse :</strong> <span className="hidden xs:inline">les déductions sur les rénovations vont disparaître progressivement</span><span className="xs:hidden">déductions rénovation supprimées</span> (entrée estimée 2028)
          </span>
        </div>
        
        <div className="flex items-center gap-2 sm:gap-3">
          <Button 
            onClick={onSimulatorClick}
            size="sm"
            className="bg-white text-orange-600 hover:bg-orange-50 font-semibold whitespace-nowrap text-xs sm:text-sm h-8 sm:h-9 px-2 sm:px-3"
          >
            <Calculator className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
            <span className="hidden sm:inline">Simuler mes économies</span>
            <span className="sm:hidden">Simuler</span>
          </Button>
          <button 
            onClick={() => setIsVisible(false)}
            className="text-white/70 hover:text-white p-0.5 sm:p-1"
            aria-label="Fermer"
          >
            <X className="h-4 w-4 sm:h-5 sm:w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};
